import {h, Component} from 'preact';
import draftToHtml from 'draftjs-to-html';
import style from './style.scss'
import aliases from './aliases'
import textToAliases from './textToAliases';
import emojiRegex from "emoji-regex";

const unicodeEmojiRegex = emojiRegex();
//eslint-disable-next-line
const aliasesRegex = /:([\w\-\_\+]+):/g;
//eslint-disable-next-line
const textEmojiRegex = /(\:\w+\:|\<[\/\\]?3|[\(\)\\\D|\*\$][\-\^]?[\:\;\=]|[\:\;\=B8][\-\^]?[3DOPp\@\$\*\\\)\(\/\|])(?=\s|[\!\.\?]|$)/g;
const urlRegex = /^((?!href|src).)*(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.;]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.;])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.;]*\)|[A-Z0-9+&@#\/%=~_;|$])/gim


const shortCodeRegex= /:[0-9a-z-+_]+:/gi


// avoid runtime RegExp creation for not so smart,
// not JIT based, and old browsers / engines
// https://github.com/twitter/twemoji/blob/gh-pages/2/twemoji.js#L232
const UFE0Fg = /\uFE0F/g;

// \u200D is a zero-width joiner character
// https://github.com/twitter/twemoji/blob/gh-pages/2/twemoji.js#L235
const U200D = String.fromCharCode(0x200d);

// convert utf16 into code points
function toCodePoint(input, separator = "-") {
  const codePoints = [];
  for (let codePoint of input) {
    codePoints.push(codePoint.codePointAt(0).toString(16));
  }
  return codePoints.join(separator);
}

function unicodeToCodepoint(input) {
    if(!input) return input
  return toCodePoint(
    input.indexOf(U200D) < 0 ? input.replace(UFE0Fg, "") : input
  );
}

export default class TextDisplay extends Component {

     /**
   * Replaces unicode emojis by twemojis as <img> tags
   * @param {*} text
   * @returns text with twemojis
   */
    toSmileyImage(text){
        // Set the source for the emojis. Now using locally hosted twemojis
        const options = {
            baseUrl: '/common/assets/twemoji/',
            size: '72x72',
            ext: 'png'
        }
        const separator = options.size ? "/" : "";
        let codepoint, src;
        if(!text)return ''
        text = text
                .replace(shortCodeRegex, (match)=> {
                    // match :smile:
                    const fullMatchContent = match.slice(1, -1); // remove ":" at the beginning and en
                    codepoint = unicodeToCodepoint(aliases[fullMatchContent]);  // Find code matching the emoji
                    if(!codepoint) return `:${match}:`
                    src = `${options.baseUrl}${options.size}${separator}${codepoint}.${options.ext}`  // Find the matching emoji from ...assets/twemoji
                    return `<img src="${src}" style="width: 1em; height: 1em"/>`  // Create image element with asset to replace the :emoji: with
                })
                .replace(unicodeEmojiRegex, (match)=> {
                    // match 😁
                    let codepoint = unicodeToCodepoint(match);  // Find code matching the emoji
                    if(!codepoint) return match
                    src = `${options.baseUrl}${options.size}${separator}${codepoint}.${options.ext}`  // Find the matching emoji from ...assets/twemoji
                    return `<img src="${src}" style="width: 1em; height: 1em"/>`  // Create image element with asset to replace the :emoji: with
                })
        return text
    }

    /**
   * Identifies links with urlRegex and replaces them by clickable anchor-tags
   * @param {*} text
   * @returns text with clickable links
   */
    toLink(text){
        return text.replace( urlRegex, (url)=>{
            let text = url
            if(url.search(/(http(s)?:\/\/)/g) === -1){
                url = '//' + url
            }
            url = url.replace("<p>", "")
            return `<a href='${url}' target='_blank'>${text}</a>`
        })
    }

    /**
    * Processes text before sending it to toSmileyImage and toLink so that it is unformatted
    * @param {*} text to process
    * @returns processed text
    */
    processText2(text){
        try {
            // Try to parse it as if it were JSON-formatted.
            // If it isn't JSON-formatted the following line will throw an error.
            let parsed = JSON.parse(text.replace('_self', '_blank')) // replace target to new tab instead of change in iframe
            /*
                draftohtml add extra /&nbsp; to avoid trimming, but we need the space for the smiley, so i had to replace it back // tuan
            */
            // Make sure it is an object before converting it to HTML, otherwise it will not have the intended effect
            if(typeof parsed === 'object'){
                parsed = draftToHtml(parsed).replace(/&nbsp;/g, ' ')
            }
            //withLink = this.toLink(htmlText)
            return this.toLink(this.toSmileyImage(parsed))
        } catch(error){
            // If the text isn't JSON-formatted the error gets caught here.
            return this.toLink(this.toSmileyImage(text))
        }
    }


    render() {
        const {text, ellipsis} = this.props
        if(!text) return ''
        let message = this.processText2(this.props.text);
        let ellips = ellipsis?' ellipsis':''
        return  <div className={style.Wrapper + ellips} dangerouslySetInnerHTML={{__html: message}}/>
    }
}



// WEBPACK FOOTER //
// ./components/TextDisplay/index.js